<template>
    <div>
        <div class="title-box">
            <div class="row title-box-wrapper">
                <div class="col-lg-11">
                    <span class="circle"></span>
                    <span class="title">{{ t(title) }}</span>
                </div>
                <div class="col-lg-1" v-if="showToggleFilterButton">
                    <toggle-button class="pull-right toggle-button"
                        @change="toggleFilterPanel"
                        :value="toggleButtonValue"
                        :height="25"
                        :width="100"
                        :labels="{checked: t('Hide filters'), unchecked: t('Show filters')}"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ToggleButton from 'vue-js-toggle-button';
    import Vue from "vue";
    Vue.use(ToggleButton);

    export default {
        comments: {},
        props: {
            title: {
                type: String,
                default: ''
            },
            toggleButtonValue: {
                type: Boolean,
                default: true
            },
            showToggleFilterButton: {
                type: Boolean,
                default: true
            }
        },
        data()
        {
            return {
            }
        },
        methods: {
            toggleFilterPanel(event) {
                this.$emit('toggleFilterPanel', event.value);
            }
        }
    }
</script>




// WEBPACK FOOTER //
// PanelHeader.vue?56cee88a